import GoogleTagManager from '@package/components/GoogleTagManager/GoogleTagManager';
import { Helmet } from '@plone/volto/helpers';
import React from 'react';
import { connect } from 'react-redux';
const RAZZLE_GMAPS_API_KEY = __CLIENT__
  ? window?.env?.RAZZLE_GMAPS_API_KEY || process.env.RAZZLE_GMAPS_API_KEY
  : process.env.RAZZLE_GMAPS_API_KEY;

const GlobalAppExtras = ({ pathname, userid }) => {
  return (
    <>
      <Helmet titleTemplate={`%s - VisitModena`} />
      <Helmet>
        <meta property="og:type" content="website"></meta>
        {userid && RAZZLE_GMAPS_API_KEY && (
          <script
            src={`https://maps.googleapis.com/maps/api/js?key=${RAZZLE_GMAPS_API_KEY}&libraries=places`}
          ></script>
        )}
      </Helmet>
      <GoogleTagManager />
    </>
  );
};

export default connect(
  (state, props) => ({
    pathname: props.location?.pathname,
    userid: props.userId,
  }),
  {},
)(GlobalAppExtras);
